import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Avatar from "@material-ui/core/Avatar";
import Grey from "@material-ui/core/colors/grey";

const styles = theme => ({
  moreLink: {
    fontSize: 14
  },
  avatar: {
    width: "24px",
    height: "24px",
    marginRight: theme.spacing.unit
  },
  answerItemBox: {
    border: '1px solid',
    padding: theme.spacing.unit,
    borderColor: Grey[400],
    borderRadius: '5px',
    fontSize: '14px'
  },
  avatarBox: {
    display: 'flex',
    marginRight: theme.spacing.unit
  }
});
function AnswerItem(props) {
  const { classes } = props;
  const post = props.post;
  return (
    <Grid xs={12} md={6} item>
        <div className={classes.answerItemBox}>
        <Grid container alignItems="center">
            <Link href={post.userUrl} target="_blank">
              <div className={classes.avatarBox}>
              <Avatar
                  alt="UserName"
                  src={post.avatar}
                  className={classes.avatar}
              />
              <span>{post.handle}</span>
              </div>
            </Link>
            <div>
            {post.content}
            </div>
        </Grid>
        <Typography variant="body1">
            <Link href={post.url} className={classes.moreLink} target="_blank">もっと見る</Link>
        </Typography>
        </div>
    </Grid>
  );
}

AnswerItem.propTypes = {
  post: PropTypes.object.isRequired
};
export default withStyles(styles)(AnswerItem);